define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var KendoDataExtracter = (function () {
        function KendoDataExtracter() {
        }
        KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry = function (dataItem) {
            return (dataItem).toJSON();
        };
        KendoDataExtracter.SetKendoDatasourceEntryFromObject = function (dataSource, dataTarget, keysToExclude) {
            if (keysToExclude === void 0) { keysToExclude = []; }
            for (var prop in dataSource)
                if (dataTarget.hasOwnProperty(prop) && keysToExclude.indexOf(prop) === -1)
                    dataTarget.set(prop, dataSource[prop]);
        };
        return KendoDataExtracter;
    }());
    exports.KendoDataExtracter = KendoDataExtracter;
});
//# sourceMappingURL=KendoDataExtracter.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Shared/KendoDataExtracter.js
// module id = 48
// module chunks = 0